import { type JSX } from "react";

import { cn } from "@/utils/core/generalUtils";

type TypoProps = ReactChildren & ClassName & { title?: string };

const H1 = ({ children, className }: TypoProps): JSX.Element => {
  return <h1 className={cn("text-4xl font-medium", className)}>{children}</h1>;
};

const H2 = ({ children, className, title }: TypoProps): JSX.Element => {
  return (
    <h2
      className={cn("font-medium text-2xl 3xl:text-2xl", className)}
      title={title}
    >
      {children}
    </h2>
  );
};

const H3 = ({ children, className }: TypoProps): JSX.Element => {
  return <h3 className={cn("text-lg font-semibold", className)}>{children}</h3>;
};

const H4 = ({ children, className }: TypoProps): JSX.Element => {
  return <h2 className={cn("text-xl font-semibold", className)}>{children}</h2>;
};
const H5 = ({ children, className }: TypoProps): JSX.Element => {
  return <h5 className={cn("font-medium text-md", className)}>{children}</h5>;
};

const P = ({ children, className }: TypoProps): JSX.Element => {
  return <p className={cn("text-sm font-normal", className)}>{children}</p>;
};

export { H1, H2, H3, H4, H5, P };
